import { useContext, useEffect } from "react";
import { useNavigate } from "react-router";

import { AuthContext } from "../context/AuthContext";
import Web2LeadContainer from "../components/web2lead/index";
import "../assets/css/web-to-lead.css";
import { subscriptionPlans, userRoles } from "../config";
import { getUserInfo } from "../utils/utils";
import useUpgradeAlert from "../common/hooks/useUpgradeAlert";

const Web2Lead = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isWebToLeadView, subscription } =
    useContext(AuthContext);
  const { role } = getUserInfo();
  const showUpgradeAlert = useUpgradeAlert(() => navigate("/pricing"));

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/signin");
    }
    if (
      role === userRoles?.admin &&
      [subscriptionPlans?.trail].includes(
        subscription?.subscriptionPackage?.name
      )
    ) {
      showUpgradeAlert();
    } else if (!isWebToLeadView) {
      navigate("/dashboard-view");
    }
  }, [isWebToLeadView, navigate, isAuthenticated]);

  return <Web2LeadContainer />;
};

export default Web2Lead;
